import React from 'react';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';

import FooterLogoPng from 'src/assets/images/footer_logo.svg';
import AccessibilityIcon from 'src/assets/images/accessibilityIcon.png';
import { mobilePoint } from 'src/styles/globalStyle';
import { useLocation } from 'react-router-dom';

const FooterWrapper = styled.div<{ isHome: boolean }>`
  display: flex;
  padding: 30px 60px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.isHome ? 'transparent' : colors.white)};
  @media (max-width: ${mobilePoint}) {
    flex-direction: column;
    align-items: flex-start;
    padding: 30px 0px;
  }
`;
const FooterLogo = styled.img`
  height: 47px;
  @media (max-width: ${mobilePoint}) {
    padding-left: 32px;
    height: 37px;
  }
`;
const FooterTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 32px;
  gap: 8px;
  @media (max-width: ${mobilePoint}) {
    padding: 16px 36px;
  }
`;
const FooterText = styled.span`
  font-family: NotoSansTC-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: ${colors.BlueGray_500};
  line-height: 155%;
`;
const FooterLinkWrapper = styled.span`
  display: flex;
  flex-wrap: wrap;
`;
const FooterLink = styled.a`
  font-family: NotoSansTC-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 155%;
`;
const LinkSeparator = styled.span`
  font-size: 14px;
  line-height: 155%;
`;

/**
 * 網站 Footer。
 */
const Footer: React.FC = () => {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  return (
    <FooterWrapper isHome={isHome}>
      <FooterLogo src={FooterLogoPng} alt="經濟部智慧財產局權證查詢系統 LOGO" />
      <FooterTextWrapper>
        <FooterText>
          本系統資料僅供參考，不作為准駁之依據，所有資料以經濟部智慧財產局公告為準。
        </FooterText>
        <FooterLinkWrapper>
          <FooterLink
            href="https://tiponet.tipo.gov.tw/030_OUT_V1/personalData"
            target="_blank"
            rel="noopener"
			title="另開隱私權政策視窗"
          >
            隱私權政策
          </FooterLink>
          <LinkSeparator>｜</LinkSeparator>
          <FooterLink
            href="https://tiponet.tipo.gov.tw/030_OUT_V1/networkSecurity"
            target="_blank"
            rel="noopener"
			title="另開網站安全政策視窗"
          >
            網站安全政策
          </FooterLink>
          <LinkSeparator>｜</LinkSeparator>
          <FooterLink
            href="https://tiponet.tipo.gov.tw/030_OUT_V1/copyRight"
            target="_blank"
            rel="noopener"
			title="另開著作權聲明視窗"
          >
            著作權聲明
          </FooterLink>
          <LinkSeparator>｜</LinkSeparator>
          <FooterLink href="https://data.gov.tw/privacy" target="_blank" rel="noopener" title="另開資料使用規範視窗">
            資料使用規範
          </FooterLink>
        </FooterLinkWrapper>
        <FooterText>
          地址：10637 臺北市辛亥路2段185號3樓 客服電話：(02)8176-9009 傳真：(02)2377-9875
        </FooterText>
      </FooterTextWrapper>
          <FooterLink href="https://accessibility.moda.gov.tw/Applications/Detail?category=20260714152458" title="無障礙網站">
              <img src={AccessibilityIcon} width="88" height="31" alt="通過AA無障礙網頁檢測" />
          </FooterLink>
    </FooterWrapper>
  );
};

export default Footer;
